// extracted by mini-css-extract-plugin
module.exports = {"buttons":"style-module__buttons___YPBNX","languageSelector":"style-module__languageSelector___2xX+l"};